<template>
  <v-dialog v-model="show" width="700" @click:outside="closeModal">
    <v-card>
      <v-card-title class="text-h5 white--text" style="background-color: #5087e6">
        {{ text_setting.title }}
      </v-card-title>

      <v-card-text class="pt-6">
        <v-form ref="form" class="mx-2" lazy-validation @submit.prevent>
          <v-row>
            <v-col cols="12" lg="12" md="12" xs="12">
              <h4>
                名稱
                <span class="error-message">(必填)</span>
              </h4>

              <v-text-field
                v-model="setting.name"
                outlined
                dense
                class="pa-0 ma-0"
                :rules="[rules.required]"
                validate-on-blur
                :hint="'設定名稱，幫助你來辨認'"
              >
              </v-text-field>
            </v-col>
          </v-row>

          <v-row class="pt-0 mt-0">
            <v-col class="pt-0" cols="12" lg="12" md="12" xs="12">
              <h4>
                編輯器頁面
                <span class="error-message">(必填)</span>
              </h4>

              <v-text-field
                v-model="setting.url"
                outlined
                dense
                class="pa-0 ma-0"
                :rules="[rules.required, rules.validateUrl]"
                validate-on-blur
                :hint="'要編輯的網頁'"
                :disabled="setting.release"
              >
              </v-text-field>
            </v-col>
          </v-row>

          <v-row class="pt-0 mt-0">
            <v-col class="pt-0" cols="12" lg="12" md="12" xs="12">
              <h4>實驗說明</h4>

              <v-text-field
                v-model="setting.memo"
                outlined
                dense
                class="pa-0 ma-0"
                :rules="[]"
                validate-on-blur
                :hint="'寫下對團隊有幫助的說明'"
                :disabled="setting.release"
              >
              </v-text-field>
            </v-col>
          </v-row>

          <v-row class="mt-0">
            <v-col cols="12" lg="6" md="6" xs="6" class="pt-0 pb-0">
              <h5 class="subtitle-2 pa-0">
                開始時間
                <span class="error-message">(必填)</span>
              </h5>
              <div>
                <date-picker
                  v-model="setting.start_at"
                  :shortcuts="$utils.date_picker_shorcuts"
                  class="date-picker"
                  :class="{ 'error-message': start_at_message !== '' }"
                  style="width: 100%"
                  type="datetime"
                  value-type="format"
                  format="YYYY-MM-DD HH:mm"
                  :disabled="setting.release"
                  @click="start_at_message = ''"
                >
                </date-picker>
                <div>
                  <small class="error-message pl-3">{{ start_at_message }}</small>
                </div>
              </div>
            </v-col>
            <v-col cols="12" lg="6" md="6" xs="6" class="pt-0 pb-0">
              <h5 class="subtitle-2 pa-0">
                結束時間
                <span class="error-message">(必填)</span>
              </h5>
              <div>
                <date-picker
                  v-model="setting.end_at"
                  class="date-picker"
                  :class="{ 'error-message': end_at_message !== '' }"
                  style="width: 100%"
                  type="datetime"
                  value-type="format"
                  format="YYYY-MM-DD HH:mm"
                  :disabled-date="chooseEndDateRange"
                  :disabled="(!setting.enable && setting.release) || !setting.start_at"
                  @click="end_at_message = ''"
                >
                </date-picker>
                <div>
                  <small class="error-message pl-3">{{ end_at_message }}</small>
                </div>
              </div>
            </v-col>
          </v-row>
        </v-form>
      </v-card-text>

      <v-divider></v-divider>

      <v-card-actions class="justify-end">
        <v-btn color="grey" text @click="closeModal">
          {{ text_setting.cancel_text }}
        </v-btn>
        <v-btn color="primary" text @click="submitModal">
          {{ text_setting.submit_text }}
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import DatePicker from 'vue2-datepicker'
import 'vue2-datepicker/index.css'
import 'vue2-datepicker/locale/zh-tw'

export default {
  name: 'ExperienceModal',
  components: {
    DatePicker,
  },
  props: {
    text_setting: Object,
    init_setting: Object,
  },
  data: function () {
    return {
      show: true,
      rules: this.$utils.field_rules,
      start_at_message: '',
      start_at_edit: false,
      end_at_message: '',
      end_at_edit: false,
      setting: {},
    }
  },
  created: function () {
    console.log('setting', this.setting)
    console.log('text_setting', this.text_setting)
    this.setting = JSON.parse(JSON.stringify(this.init_setting))
  },
  methods: {
    chooseEndDateRange(choose_date) {
      return choose_date < new Date(this.setting.start_at)
    },
    closeModal: function () {
      this.$emit('close')
    },
    submitModal: async function () {
      // 驗證欄位
      let form_result = this.$refs.form.validate()
      console.log(form_result)
      let is_pass = []
      if (!this.setting.start_at) {
        this.start_at_message = '必填爛位'
        is_pass.push(false)
      }
      if (!this.setting.end_at) {
        this.end_at_message = '必填爛位'
        is_pass.push(false)
      }

      if (is_pass.includes(false) || !form_result) {
        return
      }

      console.log(this.setting)
      this.$emit('submit', this.setting)
    },
  },
}
</script>
<style scoped>
.error-message {
  color: #ff1744;
}

.date-picker >>> .mx-input {
  height: 40px;
}

.date-picker.error-message >>> .mx-input {
  border-color: #ff1744;
  border-width: 2px;
}
</style>
